import { FC } from 'react';
import { withStyles, Card, CportalServiceItem, CportalService, Box } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Title, Toggle } from 'UI';
import styles from './Services.module.scss';

const cn = withStyles(styles);

type ServicesProps = {
  isEnabled: boolean;
  services: CportalServiceItem[];
};

const Services: FC<ServicesProps> = ({ isEnabled, services }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Customers.CportalTab' });

  const defaultServices: CportalServiceItem[] = [
    { Service: 'Fund', Enabled: false },
    { Service: 'Transfer', Enabled: false },
    { Service: 'Withdraw', Enabled: false },
    { Service: 'Global Send', Enabled: false },
  ];

  const displayedServices = isEnabled && services?.length ? services : defaultServices;
  const serviceOrder = ['Fund', 'Withdraw', 'Transfer', 'Global Send'];

  const serviceLabelMap: Record<CportalService, string> = {
    Fund: t('fundWallet', { defaultValue: 'Fund wallets' }),
    Withdraw: t('withdrawWallet', { defaultValue: 'Withdraw from wallets' }),
    Transfer: t('transferWallet', { defaultValue: 'Transfer between wallets' }),
    'Global Send': t('globalSend', { defaultValue: 'Global Send' }),
  };

  return (
    <div className={cn('container')}>
      <Box flx="col" gapSize="2px" padding="16px 0 0 12px">
        <Title level="6">{t('services', { defaultValue: 'Services' })}</Title>
        <div className={cn('description')}>
          {t('servicesDescription', { defaultValue: 'Manage services related to cPortal account.' })}
        </div>
      </Box>

      <Card className={cn('serviceContainer')} hoverEffect={false}>
        {displayedServices
          .filter((service) => service.Service !== 'Global Send')
          .sort((a, b) => serviceOrder.indexOf(a.Service) - serviceOrder.indexOf(b.Service))
          .map((service) => (
            <div key={service.Service} className={cn('toggleContainer')}>
              <Toggle
                name={`enable-${service.Service}`}
                checked={service.Enabled}
                readOnly
                label={serviceLabelMap[service.Service]}
              />
            </div>
          ))}
      </Card>
    </div>
  );
};

export default Services;
